/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Polish (Poland)
export default {
  'editorExtensionLinkCreate.confluencePage.newDraftTitle': 'Strona bez tytułu',
  'editorExtensionLinkCreate.confluencePage.quickInsert.description': 'Utwórz nową stronę i wstaw ją jako łącze',
  'editorExtensionLinkCreate.confluencePage.quickInsert.title': 'Utwórz stronę Confluence',
  'editorExtensionLinkCreate.confluencePage.successFlag.action.open': 'Otwórz w Confluence',
  'editorExtensionLinkCreate.confluencePage.successFlag.description': 'Twoja strona została utworzona',
  'editorExtensionLinkCreate.confluencePage.successFlag.title': 'Strona utworzona',
  'editorExtensionLinkCreate.confluencePage.title': 'Utwórz nową stronę',
  'editorExtensionLinkCreate.genericError.description': 'Odśwież stronę i spróbuj ponownie.',
  'editorExtensionLinkCreate.genericError.title': 'Coś poszło nie tak',
  'editorExtensionLinkCreate.jiraIssue.quickInsert.description': 'Utwórz zgłoszenie w wierszu i wstaw je jako łącze',
  'editorExtensionLinkCreate.jiraIssue.quickInsert.title': 'Utwórz zgłoszenie Jira',
  'editorExtensionLinkCreate.jiraIssue.successFlag.action.open': 'Otwórz w Jirze',
  'editorExtensionLinkCreate.jiraIssue.successFlag.description': 'Twoje zgłoszenie zostało utworzone',
  'editorExtensionLinkCreate.jiraIssue.successFlag.title': 'Utworzono zgłoszenie',
  'editorExtensionLinkCreate.jiraIssue.title': 'Utwórz nowe zgłoszenie',
  'editorExtensionLinkCreate.keyword.create': 'utwórz',
  'editorExtensionLinkCreate.keyword.issue': 'zgłoszenie',
  'editorExtensionLinkCreate.keyword.new': 'nowe',
  'editorExtensionLinkCreate.keyword.page': 'strona',
  'editorExtensionLinkCreate.keyword.publish': 'opublikuj',
  'editorExtensionLinkCreate.keyword.raise': 'zgłoś',
  'editorExtensionLinkCreate.keyword.space': 'przestrzeń',
  'editorExtensionLinkCreate.keyword.ticket': 'zgłoszenie',
};
